import { cEl } from '../../../util';
import check from '../../../assets/images/check.svg';
import { navigateTo } from '../../AppHeader/Link';
import { PATH_HOME } from '../../path';

function CompleteMassage(contactInfo) {
    const completeContainer = cEl('div');
    completeContainer.classList.add('complete-container');
    completeContainer.innerHTML = `
        <div class="complete-title">
            <i class="icon-check"><img src="${check}" alt="check" ></i>
            <span class="complete-message">1:1 문의가 정상적으로 접수되었습니다.</span>
        </div>
        <div class="complete-contents">
            <div class="content-item">
                <div class="content-label">성명</div>
                <div class="content-value" title="${contactInfo.name}">${contactInfo.name}</div>
            </div>
            <div class="content-item">
                <div class="content-label">소속 기관</div>
                <div class="content-value" title="${contactInfo.affiliation}">${contactInfo.affiliation ?? ''}</div>
            </div>
            <div class="content-item">
                <div class="content-label">회신 연락처</div>
                <div class="content-value" title="${contactInfo.phone}">${contactInfo.phone}</div>
            </div>
            <div class="content-item">
                <div class="content-label">회신 이메일</div>
                <div class="content-value" title="${contactInfo.email}">${contactInfo.email}</div>
            </div>
        </div>
        `;

    const buttonWrapper = cEl('div');
    buttonWrapper.classList.add('button-wrapper');

    const homeButton = cEl('button');
    homeButton.classList.add('button', 'brand-button');
    homeButton.type = 'button';
    homeButton.innerHTML = '홈으로';
    homeButton.addEventListener('click', e => {
        navigateTo(PATH_HOME);
    });
    buttonWrapper.appendChild(homeButton);

    const completeContainerWrapper = cEl('div');
    completeContainerWrapper.append(completeContainer, buttonWrapper);
    return completeContainerWrapper;
}

export default CompleteMassage;
